//
import Service from '@/services/api/service'
import AccPurchaseSaleBookModel from '@/models/Accounting/AccPurchaseSaleBook'

/**
 * @description
 * This class describes a sl tax document.
 *
 * @class      SlTaxDocument (name)
 */
export default class AccPurchaseSaleBookService extends Service {

  /**
	 * @description
   * { item_description }
   */
  static model = AccPurchaseSaleBookModel

  /**
   * { function_description }
   *
   * @param      {<type>}   data    The data
   * @return     {Promise}  { description_of_the_return_value }
   */
  static async changeSaleDocs(data) {
    return this
      .shape({ id: 'change_sale_docs' })
      .attach(data)
  }
}
